/**
 * FikoBukum — Sac Metal Büküm Açınımı (Flat Pattern) motoru
 * Flanş (düz kenar) + büküm (açı, iç yarıçap) → bend allowance (K-faktör) → düz açınım boyu.
 * Lazer/abkant üretimi için sac levha açılım ölçüsü.
 */

export interface BukumOge { aci: number; icYaricap: number; }   // açı (derece, büküm miktarı), iç yarıçap (mm)

export interface BukumGirdi {
  kalinlik: number;     // sac kalınlığı (mm)
  kFaktor: number;      // nötr eksen K-faktörü (0.3–0.5)
  flanslar: number[];   // düz kenar uzunlukları (mm) — N adet
  bukumler: BukumOge[]; // N-1 adet büküm (flanşlar arası)
}

export interface BukumSonuc {
  bendAllowances: number[];   // her büküm için BA (mm)
  toplamFlans: number;
  toplamBA: number;
  flatBoy: number;            // düz açınım toplam boyu (mm)
  bukumSayisi: number;
}

/** Bend Allowance: BA = (π/180)·açı·(r + K·t). */
export function bendAllowance(aci: number, icYaricap: number, kalinlik: number, kFaktor: number): number {
  return (Math.PI / 180) * (aci || 0) * ((icYaricap || 0) + (kFaktor || 0) * (kalinlik || 0));
}

export function bukumHesapla(g: BukumGirdi): BukumSonuc {
  const toplamFlans = (g.flanslar || []).reduce((t, f) => t + (+f || 0), 0);
  const bendAllowances = (g.bukumler || []).map(b => bendAllowance(b.aci, b.icYaricap, g.kalinlik, g.kFaktor));
  const toplamBA = bendAllowances.reduce((t, b) => t + b, 0);
  return {
    bendAllowances, toplamFlans, toplamBA,
    flatBoy: toplamFlans + toplamBA,
    bukumSayisi: bendAllowances.length,
  };
}
